import React, { useState } from "react";
import RenderButton from "./../../components/common/button";
import DatePicker from "react-datepicker";

const Headder = ({onChange,name}) => {
  const [all, setall] = useState("btn btn-primary");
  const [sld, setsld] = useState("btn btn-outline-dark");
  const [PTC, setPTC] = useState("btn btn-outline-dark");
  const [SAK, setSAK] = useState("btn btn-outline-dark");
  const [BAK, setBAK] = useState("btn btn-outline-dark");
  const [PSD, setPSD] = useState("btn btn-outline-dark");
  const [HTL, setHTL] = useState("btn btn-outline-dark");
  const [CTR, setCTR] = useState("btn btn-outline-dark");
  const [CBD, setCBD] = useState("btn btn-outline-dark");
  const [WTN, setWTN] = useState("btn btn-outline-dark");
  const [MAL, setMAL] = useState("btn btn-outline-dark");
  const [PNM, setPNM] = useState("btn btn-outline-dark");
  const [NOB, setNOB] = useState("btn btn-outline-dark");
  const [startDate, setStartDate] = useState(new Date());
  const handleonClick = ({ currentTarget: input }) => {
    if (input.value == 520) {
      name="โรงชิพศาลาลำดวน"  
   
      disabledlabel();
      setsld("btn btn-primary");
    } else if (input.value == 1) { 
      disabledlabel();
      setall("btn btn-primary");
    } else if (input.value == 523) {    
      name="โรงชิพปักธงชัย"  
    
      disabledlabel();
      setPTC("btn btn-primary");
    } else if (input.value == 525) {
      name="โรงชิพสังขะ"
      disabledlabel();
      setSAK("btn btn-primary");
    } else if (input.value == 526) {
      name="โรงชิพบ้านกรวด"
      disabledlabel();
      setBAK("btn btn-primary");
    } else if (input.value == 527) {
      name="โรงชิพห้วยแถลง"
      disabledlabel();
      setHTL("btn btn-primary");
    } else if (input.value == 533) {
      name="โรงชิพหนองบัว"
      disabledlabel();
      setNOB("btn btn-primary");
    } else if (input.value == 530) {
      disabledlabel();
      setCBD("btn btn-primary");
    } else if (input.value == 529) {
      name="โรงชิพวัฒนานคร"
      disabledlabel();
      setWTN("btn btn-primary");
    } else if (input.value == 528) {
      name="โรงชิพจัตุรัส"
      disabledlabel();
      setCTR("btn btn-primary");
    } else if (input.value == 531) {
      name="โรงชิพปางสีดา"
      disabledlabel();
      setPSD("btn btn-primary");
    } else if (input.value == 697) {
      name="โรงชิพมาลัย"
      disabledlabel();
      setMAL("btn btn-primary");
    } else if (input.value == 500) {
      name="โรงชิพIP2"
      disabledlabel();
      setPNM("btn btn-primary");
    }
    onChange(input.value);
  };
  // const handleChange = (date) => {
  //     setStartDate(date)
  //     handleDateChange(date);
  // }

  const disabledlabel = () => {
    setall("btn btn-outline-dark");
    setsld("btn btn-outline-dark");
    setPTC("btn btn-outline-dark");
    setWTN("btn btn-outline-dark");
    setSAK("btn btn-outline-dark");
    setCTR("btn btn-outline-dark");
    setNOB("btn btn-outline-dark");
    setBAK("btn btn-outline-dark");
    setPSD("btn btn-outline-dark");
    setHTL("btn btn-outline-dark");
    setCBD("btn btn-outline-dark");
    setPNM("btn btn-outline-dark");
    setMAL("btn btn-outline-dark");
  };

  return (
  
      <div className="row">
        <div className="col-auto mb-1 px-0 ">
          <RenderButton
            label="กรุณาเลือก"
            value="1"
            onClick={handleonClick}
            className={all}
          />
          <RenderButton
            value="520"
            label="ศาลาลำดวน"
            onClick={handleonClick}
            className={sld}
          />
          <RenderButton
            value="529"
            label="วัฒนานคร"
            onClick={handleonClick}
            className={WTN}
          />
          <RenderButton
            value="531"
            label="ปางสีดา"
            onClick={handleonClick}
            className={PSD}
          />
          <RenderButton
            value="533"
            label="หนองบัว"
            onClick={handleonClick}
            className={NOB}
          />
          <RenderButton
            value="523"
            label="ปักธงชัย"
            onClick={handleonClick}
            className={PTC}
          />
          <RenderButton
            value="527"
            label="ห้วยแถลง"
            onClick={handleonClick}
            className={HTL}
          />

          <RenderButton
            value="528"
            label="จัตุรัส"
            onClick={handleonClick}
            className={CTR}
          />
          <RenderButton
            value="526"
            label="บ้านกรวด"
            onClick={handleonClick}
            className={BAK}
          />
          <RenderButton
            value="525"
            label="สังขะ"
            onClick={handleonClick}
            className={SAK}
          />
          <RenderButton
            value="500"
            label="พนม"
            onClick={handleonClick}
            className={PNM}
          />
          <RenderButton
            value="697"
            label="มาลัย"
            onClick={handleonClick}
            className={MAL}
          />

          {/* <RenderButton 
                           value="531"
                          label ="ปางสีดา"
                     onClick ={handleonClick}
                     className = {}
                      /> */}
        </div>
      </div>
 
  );
};

export default Headder;
